<template>
  <v-img class="d-inline-block" :height="height" :max-width="maxWidth" :src="icons[icon]" contain />
</template>

<script>
import visa from 'payment-icons/min/flat/visa.svg'
import mastercard from 'payment-icons/min/flat/mastercard.svg'
import discover from 'payment-icons/min/flat/discover.svg'
import amex from 'payment-icons/min/flat/amex.svg'
import defaultCC from 'payment-icons/min/flat/default.svg'

export default {
  name: 'CCIcon',
  props: {
    height: {
      type: [String, Number],
      default: 32
    },
    maxWidth: {
      type: [String, Number],
      default: 46
    },
    cardType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      icons: {
        visa,
        mastercard,
        discover,
        amex,
        defaultCC,
      },
      supportedCards: ['visa', 'mastercard', 'discover', 'amex']
    }
  },
  computed: {
    icon () {
      const CCType = this.cardType.toLowerCase()
      return this.supportedCards.indexOf(CCType) > -1 ? CCType : 'defaultCC'
    }
  }
}
</script>
